import { Badge, BadgeVariant } from '@moment/design-system-ui/badge'
import { BondType } from '@moment/trading-types/reference-data'
import { useMemo } from 'react'

import { formatBondType } from '@/utils/presentation/bonds'

interface BondTypeBadgeProps {
  bondType: BondType
  className?: string
}

/**
 * Badge component for displaying bond types with consistent colors and labels.
 * This component is the canonical way to display bond type badges throughout the platform.
 */
export function BondTypeBadge({
  bondType,
  className = '',
}: BondTypeBadgeProps) {
  const variant = useMemo(() => {
    switch (bondType) {
      case BondType.Agency:
        return BadgeVariant.Danger
      case BondType.Corporate:
        return BadgeVariant.Processing
      case BondType.Municipal:
        return BadgeVariant.Warning
      case BondType.Treasury:
        return BadgeVariant.Success
      case BondType.MoneyMarket:
        return BadgeVariant.Special
      // biome-ignore lint/complexity/noUselessSwitchCase: Bulk suppression as part of biome migration
      case BondType.CD:
      // biome-ignore lint/complexity/noUselessSwitchCase: Bulk suppression as part of biome migration
      case BondType.Government:
      default:
        return BadgeVariant.Neutral
    }
  }, [bondType])

  const displayValue = formatBondType(bondType)

  return (
    <Badge className={className} variant={variant}>
      {displayValue}
    </Badge>
  )
}
